import styled from '@emotion/styled';
import { Paper } from '@material-ui/core';
import { ClassAttributes, createElement, ReactElement } from 'react';

import { SPACING_REGULAR } from '../../../constant/spacing';
import Spinner from '../../compound/Spinner';
import EmptyState from './EmptyState';
import LatestProjectEmptyState from './LatestProjectEmptyState';
import { Props as ItemProps } from './ProjectListItem';

interface Props {
  showEmptyState: boolean;
  loading: boolean;
  className?: string;
  isLatest?: boolean;
  children: ReactElement<ItemProps>[];
}

const ProjectList = ({
  showEmptyState,
  loading,
  className,
  children,
  isLatest = false,
}: ClassAttributes<HTMLElement> & Props) => {
  if (loading) {
    return (
      <SpinnerContainer>
        <Spinner className={className} />
      </SpinnerContainer>
    );
  }

  if (showEmptyState) {
    return (
      <EmptyStateWrapper>
        {isLatest ? <LatestProjectEmptyState /> : <EmptyState className={className} />}
      </EmptyStateWrapper>
    );
  }

  return (
    <Root className={className}>
      <Paper>{children}</Paper>
    </Root>
  );
};

const SpinnerContainer = styled('div')({
  marginTop: SPACING_REGULAR,
});

const EmptyStateWrapper = styled('div')({
  textAlign: 'center',
  marginBottom: SPACING_REGULAR,
});

const Root = styled('div')({
  paddingRight: 2,
  paddingLeft: 2,
});

export default ProjectList;
